import React, { useState, useRef } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { modules, formats } from "../../utils/quillModules";
import { API_URL } from "../../utils/Url";
import { Sidebar } from "../sidebar/Sidebar";
import { Header } from "../header/Header";
import { toast } from "react-toastify";
import "./CreateBlogs.css";

const CreateBlogs = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [metaTitle, setMetaTitle] = useState("");
  const [metaKeyword, setMetaKeyword] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [author, setAuthor] = useState("");
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const token = sessionStorage.getItem("token");

  const resetForm = () => {
    setTitle("");
    setContent("");
    setMetaTitle("");
    setMetaKeyword("");
    setMetaDescription("");
    setAuthor("");
    setImageFile(null);
    if (imagePreview) {
      URL.revokeObjectURL(imagePreview);
      setImagePreview(null);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSubmit = async () => {
    if (loading) return;

    if (!token) {
      toast.error("Unauthorized. Please login again.");
      return;
    }

    if (!title || !content || content === "<p><br></p>") {
      toast.error("Title & Description are required");
      return;
    }

    if (!imageFile) {
      toast.warning("Blog cover image is required");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("title", title.trim());
      formData.append("description", content);
      formData.append("metaTitle", metaTitle);
      formData.append("metaKeyword", metaKeyword);
      formData.append("metaDescription", metaDescription);
      formData.append("authorName", author);
      formData.append("blogImage", imageFile);

      await axios.post(`${API_URL}/api/blog/create_blog`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Blog created successfully! 🎉");
      resetForm();
    } catch (err) {
      console.error(err.response?.data || err);
      toast.error(err.response?.data?.message || "Something went wrong ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Sidebar />

      <div className="mt-5 main-content px-3 px-md-4 py-4">
        <div className="">
          <div className="page-header">
            <h2 className="page-title">✨ Create New Article</h2>
            <p className="page-subtitle">
              Publish modern and SEO-optimized blogs to your platform
            </p>
          </div>

          <div className="form-group">
            <label>Blog Title *</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g., Understanding React Server Components"
            />
          </div>

          <div className="form-group">
            <label>Cover Image *</label>
            <div
              className="file-upload-wrapper"
              onClick={() => fileInputRef.current?.click()}
            >
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  setImageFile(file);
                  if (file) {
                    setImagePreview(URL.createObjectURL(file));
                  }
                }}
              />
              <p style={{ margin: 0, color: "#64748b", fontSize: "14px" }}>
                📁 Click to upload or drag cover image here
              </p>
            </div>

            {imagePreview && (
              <div className="image-preview-container">
                <img
                  src={imagePreview}
                  alt="Cover Preview"
                  className="image-preview"
                />
              </div>
            )}
          </div>

          <div className="form-group">
            <label>Article Content *</label>
            <ReactQuill
              value={content}
              onChange={setContent}
              modules={modules}
              formats={formats}
              className="quill-editor"
              placeholder="Write your story here..."
            />
          </div>

          <div className="section-title">
            🔍 Search Engine Optimization (SEO)
          </div>

          <div className="grid-2">
            <div className="form-group">
              <label>Meta Title</label>
              <input
                type="text"
                placeholder="SEO meta title"
                value={metaTitle}
                onChange={(e) => setMetaTitle(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Author Name</label>
              <input
                type="text"
                placeholder="Author name"
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
              />
            </div>
          </div>

          <div className="grid-2">
            <div className="form-group">
              <label>Meta Keywords</label>
              <input
                type="text"
                placeholder="react, web development, javascript"
                value={metaKeyword}
                onChange={(e) => setMetaKeyword(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Meta Description</label>
              <input
                type="text"
                placeholder="Brief summary for search results..."
                value={metaDescription}
                onChange={(e) => setMetaDescription(e.target.value)}
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-cancel" onClick={resetForm}>
              Reset
            </button>

            <button
              type="button"
              className="btn-submit"
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? "Publishing..." : "Publish Article"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateBlogs;
